var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_2048_36946)" } }, [
        _c("path", {
          attrs: {
            d: "M2.25 2.07812C2.25 0.699219 3.37109 -0.421875 4.75 -0.421875H16C17.3789 -0.421875 18.5 0.699219 18.5 2.07812V14.5781C18.5 15.957 17.3789 17.0781 16 17.0781H1.625C-0.101562 17.0781 -1.5 15.6797 -1.5 13.9531V3.32812C-1.5 2.63672 -0.941406 2.07812 -0.25 2.07812C0.441406 2.07812 1 2.63672 1 3.32812V13.9531C1 14.2969 1.28125 14.5781 1.625 14.5781C1.96875 14.5781 2.25 14.2969 2.25 13.9531V2.07812ZM4.75 3.01562V6.14062C4.75 6.66016 5.16797 7.07812 5.6875 7.07812H10.0625C10.582 7.07812 11 6.66016 11 6.14062V3.01562C11 2.49609 10.582 2.07812 10.0625 2.07812H5.6875C5.16797 2.07812 4.75 2.49609 4.75 3.01562ZM12.875 2.70312C12.875 3.04688 13.1562 3.32812 13.5 3.32812H15.375C15.7188 3.32812 16 3.04688 16 2.70312C16 2.35938 15.7188 2.07812 15.375 2.07812H13.5C13.1562 2.07812 12.875 2.35938 12.875 2.70312ZM12.875 6.45312C12.875 6.79688 13.1562 7.07812 13.5 7.07812H15.375C15.7188 7.07812 16 6.79688 16 6.45312C16 6.10938 15.7188 5.82812 15.375 5.82812H13.5C13.1562 5.82812 12.875 6.10938 12.875 6.45312ZM4.75 10.2031C4.75 10.5469 5.03125 10.8281 5.375 10.8281H15.375C15.7188 10.8281 16 10.5469 16 10.2031C16 9.85938 15.7188 9.57812 15.375 9.57812H5.375C5.03125 9.57812 4.75 9.85938 4.75 10.2031ZM4.75 13.9531C4.75 14.2969 5.03125 14.5781 5.375 14.5781H15.375C15.7188 14.5781 16 14.2969 16 13.9531C16 13.6094 15.7188 13.3281 15.375 13.3281H5.375C5.03125 13.3281 4.75 13.6094 4.75 13.9531Z",
            fill: "#010A11",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_2048_36946" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0.5 0.578125)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }